module.exports = __webpack_public_path__ + "img/operacoes-icon.4430280c.png";